import { render, staticRenderFns } from "./pricelist.vue?vue&type=template&id=147b459b&"
import script from "./pricelist.vue?vue&type=script&lang=js&"
export * from "./pricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('147b459b')) {
      api.createRecord('147b459b', component.options)
    } else {
      api.reload('147b459b', component.options)
    }
    module.hot.accept("./pricelist.vue?vue&type=template&id=147b459b&", function () {
      api.rerender('147b459b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Ctbu73K6ERw6/JS/comp/pricelist.vue"
export default component.exports